import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '../../../biLogger';
import { MobileContext } from '../../../Context';
import JournalGridBlock from '../../_partials/JournalGridBlock';
import SimpleDeviationGridBlock from '../../_partials/SimpleDeviationGridBlock';
import { getIsStreamTextType } from '../../../DeviationViews/_helpers';
export var LoveSuggestion = function (_a) {
    var _b = _a.loveSuggestion, type = _b.type, loading = _b.loading, deviations = _b.deviations, parentDeviation = _a.parentDeviation, isTextType = _a.isTextType;
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        return null;
    }
    var showAsTextType = loading || !deviations.length
        ? isTextType
        : getIsStreamTextType(deviations);
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: type } }, showAsTextType ? (React.createElement(JournalGridBlock, { streamKey: type, isLoading: loading, journals: deviations, parentDeviation: parentDeviation, maxLength: 1 })) : (React.createElement(SimpleDeviationGridBlock, { streamKey: type, isLoading: loading, parentDeviation: parentDeviation, deviations: deviations }))));
};
LoveSuggestion.displayName = 'LoveSuggestion';
export default LoveSuggestion;
//# sourceMappingURL=LoveSuggestion.js.map